import { Component } from "react"

/* Components */
import Icon from "./Icon"


/* The gap between the pages which are not drawn */
const DOTS = "..."

/* The pages between two numbers */
const range = (start, end) => Array.from({ length: end - start + 1 }, (item, index) => index + start)


/* Component Pagination — how many rows are shown out of how many, and the pages themselves.
   Only the pages around the open one are drawn, the rest hide behind a gap */
class Pagination extends Component {

    /* The pages the row is made of */
    generate = () => {

        /* Fields */
        const { total, size, page } = this.props

        const sibling = 1
        const count = Math.ceil(total / size)

        /* Everything fits without a gap */
        if (sibling + 5 >= count) {
            return range(1, count)
        }

        const left = Math.max(page - sibling, 1)
        const right = Math.min(page + sibling, count)

        const withLeftDots = left > 2
        const withRightDots = right < count - 2

        /* The open page is at the beginning */
        if (!withLeftDots && withRightDots) {
            return [...range(1, 2 + 2 * sibling), DOTS, count]
        }

        /* The open page is at the end */
        if (withLeftDots && !withRightDots) {
            return [1, DOTS, ...range(count - (2 + 2 * sibling) + 1, count)]
        }

        /* The open page is somewhere in the middle */
        if (withLeftDots && withRightDots) {
            return [1, DOTS, ...range(left, right), DOTS, count]
        }

        return []
    }

    /* Open one page — the one which is already open is not asked for again */
    go = page => {

        /* Fields */
        const { page: current, onPageChange, total, size } = this.props

        const count = Math.ceil(total / size)

        if (page < 1 || page > count || parseInt(page) === parseInt(current)) {
            return
        }

        onPageChange(page)

        /* The next page is read from its beginning and not from where the last one was left */
        window.scrollTo({ top: 0, behavior: "smooth" })
    }

    render = () => {

        /* Fields */
        const { total, size, page } = this.props

        const count = Math.ceil(total / size)

        /* One page holds everything there is */
        if (!(parseInt(total) > 0 && count > 1)) {
            return null
        }

        const pages = this.generate()

        /* Which rows are on the screen — the last page is rarely a full one */
        const from = size * (page - 1) + 1
        const to = Math.min(size * page, total)

        return (
            <div className="pagination">

                <div className="pagination-pages">

                    <div onClick={() => this.go(page - 1)} className={`pagination-item arrow ${parseInt(page) === 1 ? "disabled" : ""}`}>
                        <Icon name="left" size={16} width={2} />
                    </div>

                    {pages.map((number, index) => {

                        if (number === DOTS) {
                            return <div key={`${index}`} className="pagination-dots">{DOTS}</div>
                        }

                        return (
                            <div
                                key={`${index}`}
                                onClick={() => this.go(number)}
                                className={`pagination-item ${parseInt(page) === parseInt(number) ? "active" : ""}`}
                            >
                                {number}
                            </div>
                        )
                    })}

                    <div onClick={() => this.go(page + 1)} className={`pagination-item arrow ${parseInt(page) === count ? "disabled" : ""}`}>
                        <Icon name="right" size={16} width={2} />
                    </div>

                </div>

                <div className="pagination-text">
                    Показано <b>{from}–{to}</b> из <b>{total}</b>
                </div>

            </div>
        )
    }
}

export default Pagination
